import React from 'react';
import { BookOpen } from 'lucide-react';

/**
 * Persistent floating "Browse Catalogue" button.
 * Pairs with the WhatsApp float button. Sits above it on the right edge.
 */
const CatalogueFloat = () => {
  return (
    <a
      href="https://wa.me/c/919893254712"
      target="_blank"
      rel="noopener noreferrer"
      className="catalogue-float"
      data-testid="catalogue-float-btn"
      aria-label="Browse our full catalogue on WhatsApp"
    >
      <span className="catalogue-float-icon">
        <BookOpen size={20} />
      </span>
      <span className="catalogue-float-label">Catalogue</span>
    </a>
  );
};

export default CatalogueFloat;
